import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { formatLocalDateTime } from '@helpers/dateUtils';
import { BookkeepingEntry, entrySource } from '@api/queries/inventory';
import { EditorMode } from './hooks/useBookkeepingEntry';

const Header = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-column-gap: 10px;
  grid-template-columns: [header] auto [modified] 400px [created] 400px;
  margin-bottom: 15px;
  justify-items: start;
`;

const Created = styled.div``;

const Modified = styled.div`
  justify-self: end;
  margin-right: 20px;
`;

const Heading = styled.h2``;

interface Props {
  mode: EditorMode;
  entry?: BookkeepingEntry;
}

const EntryHeader: React.FC<Props> = ({ mode, entry }) => {
  const { t } = useTranslation();

  const headingMap: Record<EditorMode, string> = {
    new: t('entry.heading_create'),
    edit: t('entry.heading_edit'),
    approved: t('entry.heading_read'),
    readonly: t('entry.heading_read'),
  };

  const heading = headingMap[mode];
  const showTimestamps = mode !== 'new' && entry;

  const getCreatedBy = () => {
    if (!entry) return '';
    return entry.source === entrySource.User
      ? entry.createdBy
      : t(`entry.sources.${entrySource[entry.source].toLowerCase()}`);
  };

  return (
    <Header>
      <Heading>{heading}</Heading>
      {showTimestamps && entry && (
        <>
          <Modified>
            {entry.modified && (
              <>
                <div>
                  {t('entry.modified')} {formatLocalDateTime(entry.modified, true)}
                </div>
                <div>
                  {t('entry.modified_by')} {entry.modifiedBy}
                </div>
              </>
            )}
          </Modified>
          <Created>
            <div>
              {t('entry.created')} {formatLocalDateTime(entry.created, true)}
            </div>
            <div>
              {t('entry.created_by')} {getCreatedBy()}
            </div>
          </Created>
        </>
      )}
    </Header>
  );
};

export default React.memo(EntryHeader);
